import { useGetImages, useGetImagesStatus } from "@/api/studio/exports/queries";
import { ExportStatusModal } from "@/components/ui/modal";

/* Prop Types */
interface ExportVisualsModalProps {
  projectId: string;
  studyId: string;
  taskId: string;
}

/**
 * ExportVisualsModal
 *
 * Thin wrapper that fetches visuals export status/file and hands off state to the
 * generic ExportStatusModal for rendering.
 */
export const ExportVisualsModal = ({ projectId, studyId, taskId }: ExportVisualsModalProps) => {
  /* Queries */
  const { data: imagesStatus, isLoading: isImagesStatusLoading } = useGetImagesStatus(projectId, studyId, taskId);
  const { data: images, isLoading: isImagesLoading, isError: isImagesError } = useGetImages(projectId, studyId, imagesStatus?.status === "SUCCEEDED");

  /* Derived state */
  const isLoading = isImagesStatusLoading || isImagesLoading || imagesStatus?.status === "RUNNING";
  const isSuccess = !isLoading && imagesStatus?.status === "SUCCEEDED" && !!images && !isImagesError;
  const isError = !isLoading && !isSuccess;

  /* Render */
  return (
    <ExportStatusModal
      isLoading={isLoading}
      isSuccess={isSuccess}
      isError={isError}
      fileUrl={images?.fileUrl}
      loadingTitle="Exporting assets"
      loadingDescription="Please wait while we prepare the export..."
      successTitle="PNG export is ready"
      errorDescription="We couldn't prepare your export, please try again or contact support"
    />
  );
};
